// test2961
(2961 && 0);
